var render = function render(_c,_vm){return _c('div',{staticClass:"page-title-wrapper page-title",class:_vm.data.staticClass,style:(_vm.data.staticStyle)},[_c('h4',{staticClass:"page-title-wrapper__title"},[(_vm.props.title)?_c('span',[_vm._v(_vm._s(_vm.props.title))]):_vm._e(),_vm._t("title")],2),_c('div',{staticClass:"page-title-wrapper__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }